import { render, staticRenderFns } from "./parameter-setup-detail-form.vue?vue&type=template&id=04984e3a"
import script from "./parameter-setup-detail-form.vue?vue&type=script&lang=js"
export * from "./parameter-setup-detail-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports